import React, {Component, Fragment} from 'react';

class Footer extends Component {
    constructor(props) {
        super(props);
        };
    render() {
        return (
            <div className="footer-main">
                <div className="text-center">© Copyright Prime Private Network. All Rights & Reserved. Crafted with  <i
                    className="fa fa-heart text-danger" aria-hidden="true"/> <a  href="https://vytechenterprise.com/" target="_blank">by  Vytech Enterprise.</a></div>
            </div>
        );
    }
}

export default Footer;